module.exports = __webpack_public_path__ + "static/img/gq.e3876a88.svg";